<template>
    <div>
        <!-- Snackbar -->
        <v-snackbar v-model="snackbar" top :color="color" :timeout="6000">
            <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>


<v-card class="pa-10"><under-developement></under-developement></v-card>
        
    </div>
</template>

<script>
import axios from "axios";

import UnderDevelopement from '../shared/UnderDevelopement.vue';
export default {
   
    props:[
        'selected_ay',
        'selected_semester',
        'selected_standard',
        'selected_div',
        'selected_course',
        'selected_learner',
        'render1',
    ],
     components: { UnderDevelopement },
    data() {
        return {
            color: "",
            snackbar: false,
            snackbar_msg: null
        };
    },
    mounted() {
        this.onload();
    },
    methods: {
        showSnackbar(color, msg) {
            this.snackbar = true;
            this.color = color;
            this.snackbar_msg = msg;
        },
        onload()
        {
          
        }
    }
};
</script>

<style scoped>

</style>
